import * as ActionTypes from "../ActionTypes";

const initialState = {
    isLoading: false,
    error: false,
    errorMessage: "",
    success: false,
    getsuggestions:[],
    pythonLoading: false,
    pythonLoaded: false,
    pythonJobCreationLoading: false,
    pythonJobCreationData: "",
    pythonResumeCSVLoading: false,
    pythonResumeCSV: "",
    pythonScreeningLoading: false,
    pythonScreeningScore: {}

};

export const AtsProfileScoreReducer = function (state = initialState, action) {
    switch (action.type) {
        case ActionTypes.ATS_PROFILE_SCORE_GET_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: false,
                success: false,
                getsuggestions:[]
            };
        case ActionTypes.ATS_PROFILE_SCORE_GET_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                successMessage: action.payload?.message,
                getsuggestions: action.payload?.data?.data
            };
        case ActionTypes.ATS_PROFILE_SCORE_GET_ERROR:
            return {
                ...state,
                isLoading: false,
                error: false,
                success: false,
            };
        case ActionTypes.ATS_PYTHON_PROFILE_SCORE_GET_REQUEST:
            return {
                ...state,
                pythonLoading: true,
                pythonLoaded: false
            };
        case ActionTypes.ATS_PYTHON_PROFILE_SCORE_GET_SUCCESS:
            return {
                ...state,
                pythonLoading: false,
                pythonLoaded: action.payload
            };
        case ActionTypes.ATS_PYTHON_PROFILE_SCORE_GET_ERROR:
            return {
                ...state,
                pythonLoading: false,
                pythonLoaded: action.payload
            };
            case ActionTypes.ATS_PYTHON_SCREENING_SCORE_GET_REQUEST:
                return {
                ...state,
                pythonScreeningLoading: true,
                pythonScreeningScore: {}
            };
        case ActionTypes.ATS_PYTHON_SCREENING_SCORE_GET_SUCCESS:
            return {
                ...state,
                pythonScreeningLoading: false,
                pythonScreeningScore: action.payload
            };
        case ActionTypes.ATS_PYTHON_SCREENING_SCORE_GET_ERROR:
            return {
                ...state,
                pythonScreeningLoading: false,
            };
        case ActionTypes.ATS_PYTHON_JOB_CREATION_GET_REQUEST:
            return {
                ...state,
                pythonJobCreationLoading: true,
                pythonJobCreationData: ""
            };
        case ActionTypes.ATS_PYTHON_JOB_CREATION_GET_SUCCESS:
            return {
                ...state,
                pythonJobCreationLoading: false,
                pythonJobCreationData: action.payload
            };
        case ActionTypes.ATS_PYTHON_JOB_CREATION_GET_ERROR:
            return {
                ...state,
                pythonJobCreationLoading: false,
            };

        case ActionTypes.ATS_PYTHON_CSV_DATA_GET_REQUEST:
            return {
                ...state,
                pythonResumeCSVLoading: true,
                pythonResumeCSV: ""
            };
        case ActionTypes.ATS_PYTHON_CSV_DATA_GET_SUCCESS:
            return {
                ...state,
                pythonResumeCSVLoading: false,
                pythonResumeCSV: action.payload
            };
        case ActionTypes.ATS_PYTHON_CSV_DATA_GET_ERROR:
            return {
                ...state,
                pythonResumeCSVLoading: false,
            };
        default:
            return state;
    }
}